import { helper } from '@ember/component/helper';

import { get } from 'rise-ui/utils/object.js';

export function fnxHelper([ fn, ...args ], hash) {
  const { context, defaultValue, value, argCount, noMoreArgs } = hash;
  fn = context && typeof fn !== 'function' ? context[fn] : fn;
  return (...moreArgs) => {
    if (typeof fn !== 'function') {
      return defaultValue;
    }
    const allArgs = [ ...args, ...(noMoreArgs ? [] : moreArgs) ].slice(0, argCount);
    if (allArgs.length && value) {
      allArgs[0] = get(allArgs[0], value);
    }
    return fn.call(context, ...allArgs);
  };
}

export default helper(fnxHelper);
